import { createFileRoute } from "@tanstack/react-router";
import Agencias from "../pages/Agencias";

export const Route = createFileRoute("/agencias")({
  component: Agencias,
});
